import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingTop: 5,
    paddingBottom: 70,
    fontSize: 10,
    fontFamily: "Manrope",
    color: "#333",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "100%", // Not fully filled to look cleaner
    height: "100%",
    // objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  mainTitle: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: 15,
    // borderBottomWidth: 1.5,
    // borderBottomColor: "#000",
    paddingBottom: 3,
  },
  infoSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000",
  },
  infoBox: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 6,
  },
  // Fixed width for the right-side boxes to ensure perfect alignment
  rightBox: {
    width: 120,
    padding: 6,
  },
  label: {
    fontSize: 7,
    color: "#666",
    textTransform: "uppercase",
    marginBottom: 2,
    fontWeight: "bold",
  },
  value: {
    fontSize: 9,
    fontWeight: "bold",
  },
  fullWidthBox: {
    width: "100%",
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: "#000",
    padding: 6,
    marginBottom: 15,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
    borderWidth: 1, // Added full border
    borderColor: "#000",
    // borderTopWidth is now included in the '1' above
  },
  tableRow: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 22,
    alignItems: "center",
  },
  cell: {
    width: "6%", // adjust as needed
    padding: 3,
    fontSize: 7,
  },
  cellRight: {
    flex: 0.8,
    padding: 4,
    fontSize: 8,
    textAlign: "right",
    fontWeight: "bold",
  },
  signatureSection: {
    position: "absolute",
    bottom: 40,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  signBox: {
    width: "20%",
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 5,
    textAlign: "center",
    fontSize: 8,
    fontWeight: "bold",
  },
  footerPageInfo: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 7,
    color: "grey",
  },
  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  durationBox: {
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "#f2f2f2",
    padding: 10,
    marginVertical: 10,
  },

  durationItem: {
    alignItems: "center",
  },

  bold: {
    fontWeight: "bold",
    fontSize: 12,
  },

  sectionTitle: {
    fontWeight: "bold",
    fontSize: 12,
  },

  red: {
    color: "red",
    fontWeight: "bold",
  },

  totalBox: {
    marginTop: 15,
    backgroundColor: "#d4edda",
    padding: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 5,
  },

  totalText: {
    fontSize: 12,
    fontWeight: "bold",
  },

  totalAmount: {
    fontSize: 14,
    fontWeight: "bold",
    color: "red",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "95%", // Not fully filled to look cleaner
    height: "100%",
    objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  footer: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    textAlign: "center",
    fontSize: 8,
    color: "grey",
  },

  card: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 6,
    padding: 10,
    marginBottom: 10,
  },

  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
    borderBottomWidth: 1,
    borderColor: "#eee",
    paddingBottom: 4,
  },

  cardTitle: {
    fontSize: 11,
    fontWeight: "bold",
  },

  status: {
    fontSize: 9,
    fontWeight: "bold",
    color: "green",
  },

  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 3,
  },
  rowSub: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8",
    alignItems: "center",
    marginBottom: 3,
  },

  label: {
    fontSize: 8,
    color: "#666",
    marginRight: 3,
  },

  value: {
    fontSize: 9,
    fontWeight: "bold",
    marginRight: 10,
  },
  tableHeader: {
  flexDirection: "row",
  backgroundColor: "#2663EB",
  borderWidth: 1,
  borderColor: "#000",
},

cellHeader: {
  flex: 1,
  padding: 4,
  fontSize: 7,
  color: "#fff",
  fontWeight: "bold",
  textAlign: "center",
  borderRightWidth: 1,
  borderColor: "#000",
},

tableRow: {
  flexDirection: "row",
  borderLeftWidth: 1,
  borderRightWidth: 1,
  borderBottomWidth: 1,
  borderColor: "#000",
},

cell: {
  flex: 1,
  padding: 3,
  fontSize: 7,
  textAlign: "center",
  borderRightWidth: 1,
  borderColor: "#000",
},
});

const PayrollListDocument = ({ payrollListPrintData }) => {
  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );
  console.log("bondTimeportNoData:", bondTimeportNoData);
  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  console.log("payrollListPrintData:", payrollListPrintData);

  const formatCurrency = (amt) =>
    Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

  const colWidths = [
    "5%",
    "8%",
    "7%",
    "6%",
    "6%",
    "6%",
    "8%",
    "8%",
    "8%",
    "7%",
    "8%",
    "10%",
    "8%",
    "8%",
    "8%",
    "10%",
    "7%",
  ];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerSpace} fixed>
          {headerImage && (
            <Image src={headerImage} style={styles.header_image} />
          )}
        </View>
        <View style={styles.contentWrapper}>
          <Text style={styles.mainTitle}>Payroll List</Text>

          {/* TABLE HEADER */}
<View style={styles.tableHeader}>
  {[
    "Sl No",
    "Emp ID",
    "Name",
    "Job Title",
    "Department",
    "Division",
    "Status",
    "Nationality",
    "Join Date",
    "Basic Pay",
    "Allowances",
    "Increments",
    "Nr Hrs",
    "Ot Hrs",
    "Ots Hrs",
    "Abs Days",
    "Total Wage",
    // ...(Open
    //   ? [
    //       "Oth Additions",
    //       "Gross Pay",
    //       "Deductions",
    //       "Net Pay",
    //       "Loans & Adv",
    //     ]
    //   : []),
  ].map((h, i) => (
    <Text key={i} style={styles.cellHeader}>
      {h}
    </Text>
  ))}
</View>

{/* TABLE BODY */}
{payrollListPrintData?.map((d, i) => (
  <View key={i} style={styles.tableRow}>
    <Text style={styles.cell}>{i + 1}</Text>
    <Text style={styles.cell}>{d.EMP_ID}</Text>
    <Text style={styles.cell}>{d.NAME}</Text>
    <Text style={styles.cell}>{d.JOB_TITLE}</Text>
    <Text style={styles.cell}>{d.DEPARTMENT}</Text>
    <Text style={styles.cell}>{d.BRANCH}</Text>
    <Text style={styles.cell}>{d.STATUS}</Text>
    <Text style={styles.cell}>{d.NATIONALITY}</Text>
    <Text style={styles.cell}>
      {d.JOIN_DATE
        ? dayjs(d.JOIN_DATE).format("DD-MMM-YYYY")
        : "-"}
    </Text>
    <Text style={styles.cell}>{d.BASIC_PAY}</Text>
    <Text style={styles.cell}>{d.ALLOWANCES}</Text>
    <Text style={styles.cell}>{d.INCREMENTS}</Text>
    <Text style={styles.cell}>{d.NR_HRS}</Text>
    <Text style={styles.cell}>{d.OT_HRS}</Text>
    <Text style={styles.cell}>{d.OTS_HRS}</Text>
    <Text style={styles.cell}>{d.ABS_DAYS}</Text>
    <Text style={styles.cell}>{d.TOTAL_WAGE}</Text>

    {/* {Open && (
      <>
        <Text style={styles.cell}>{d.OTH_ADDITIONS}</Text>
        <Text style={styles.cell}>{d.GROSS_PAY}</Text>
        <Text style={styles.cell}>{d.DEDUCTIONS}</Text>
        <Text style={styles.cell}>{d.NET_PAY}</Text>
        <Text style={styles.cell}>{d.LOANS_AND_ADV}</Text>
      </> 
    )}*/}
  </View>
))}
        </View>
        <View style={styles.footer} fixed>
          {footerImage && (
            <Image src={footerImage} style={styles.header_image} />
          )}
        </View>
      </Page>
    </Document>
  );
};

export default PayrollListDocument;
